const FLAG_KEYS = ["hasaudiofile", "hasaudio", "has_audio"];
const PATH_KEYS = ["audios3key", "s3uri", "audiofile"];

const sourcesOf = (row: any) =>
    [row, row?.meta, row?.qa, row?.hierarchy, row?._source, row?.source, row?.sr].filter(
        (item) => item && typeof item === "object"
    );

const isAudioFlag = (value: unknown) => {
    if (value === true || value === 1) return true;
    if (typeof value !== "string") return false;

    const normalized = value.trim().toLowerCase();
    return normalized === "true" || normalized === "1" || normalized === "yes" || normalized === "has audio";
};

const hasAudioPath = (value: unknown) => typeof value === "string" && value.trim().length > 0;

export const rowHasAudio = (row: any) => {
    const sources = sourcesOf(row);

    const flagged = sources.some((source) => FLAG_KEYS.some((key) => isAudioFlag(source[key])));
    if (flagged) return true;

    return sources.some((source) => PATH_KEYS.some((key) => hasAudioPath(source[key])));
};

export const withAudioFlag = (row: any) => {
    if (!row || typeof row !== "object") return row;

    const hasaudiofile = rowHasAudio(row);

    return {
        ...row,
        hasaudiofile,
        meta: row.meta ? { ...row.meta, hasaudiofile } : row.meta,
    };
};
